var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    fill: "#09041C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3574 27.2269L21.0472 31.1357C21.491 31.1357 21.6831 30.9649 21.9136 30.7598L23.9941 28.9783L28.3051 31.807C29.0959 32.2018 29.6529 31.9939 29.8661 31.1553L32.6959 19.275C32.9468 18.2278 32.274 17.8176 31.5036 18.0745L14.8705 23.7801C13.7353 24.1749 13.7525 24.7419 14.6775 24.9988L18.93 26.1839L28.8075 20.6463C29.2724 20.3705 29.695 20.5231 29.3474 20.7989L21.3574 27.2269Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.c28189b636332fe8c9fefc66383b0478.svg";
export { ForwardRef as ReactComponent };